import React from 'react';
import classnames from '@src/helpers/classnames';
import {RequireAtLeastOne} from '@src/@types/RequireAtLeastOne';
import Translate from '@src/components/Translate/Translate';

export default function Switch(props: RequireAtLeastOne<{
    id: string,
    label: React.ReactNode,
    children: React.ReactNode,
    onChange?: React.ChangeEventHandler<HTMLInputElement>,
    bsSize?: 'sm' | 'lg',
    containerClassName?: string,
    groupProps?: React.HTMLProps<HTMLDivElement>,
    inputRef?: React.Ref<HTMLInputElement>,
}, 'label' | 'children'> & Omit<React.HTMLProps<HTMLInputElement>, 'onChange' | 'id' | 'type'>) {
    const {children, bsSize, containerClassName, groupProps = {}, inputRef, ...rest} = props;

    const label = React.Children.map(props.label ?? children, (component: React.ReactNode) => {
        if (typeof component === 'string') {
            return <Translate message={component} tag="label" className="form-check-label" htmlFor={props.id}/>;
        }

        if (!React.isValidElement<HTMLLabelElement>(component) || component.props.htmlFor) {
            return component;
        }

        return React.cloneElement(component, {htmlFor: props.id});
    });

    return <div {...groupProps} className={classnames('form-group form-check form-switch', {
        [`form-switch-${bsSize}`]: bsSize,
    }, groupProps.className, containerClassName)}>
        <input
                {...rest}
                ref={inputRef}
                type="checkbox"
                id={props.id}
                className={classnames('form-check-input cursor-pointer', props.className)}
                onChange={props.onChange}
        />

        {label}
    </div>;
}
